// function to fetch a deeply nested property from an object
// but return null if any of the component parts are missing
// this is an analogue of the ruby function of the same name
// p is an array of strings of the nested property names
// o is the object we are querying
// https://medium.com/javascript-inside/safely-accessing-deeply-nested-values-in-javascript-99bf72a0855a
export default (p, o) => (
  p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, o)
);
